export interface ChatInputTextPaste {
	id: string
	text: string
}

// A paste this big buries the prompt the user is still writing, so it travels
// as a pill instead of filling the composer.
export const LONG_PASTE_MIN_CHARS = 900
export const LONG_PASTE_MIN_LINES = 12

const countLines = (text: string) => text.split("\n").length

export const isLongPaste = (text: string) =>
	text.length >= LONG_PASTE_MIN_CHARS ||
	countLines(text) >= LONG_PASTE_MIN_LINES

export const textPasteLabel = (text: string, maxChars = 24) => {
	const firstLine = text
		.split("\n")
		.map((line) => line.trim())
		.find(Boolean)
	if (!firstLine) return "Pasted text"
	if (firstLine.length <= maxChars) return firstLine
	return `${firstLine.slice(0, maxChars).trimEnd()}...`
}

export const textPasteMeta = (text: string) => {
	const lines = countLines(text)
	if (lines > 1) return `${lines} lines`
	return `${text.length} chars`
}

export const textPastePreview = (text: string, maxChars = 600) =>
	text.length > maxChars ? `${text.slice(0, maxChars)}...` : text

export const composeMessageWithPastes = (
	value: string,
	pastes: ChatInputTextPaste[],
) =>
	[...pastes.map((paste) => paste.text.trim()), value.trim()]
		.filter(Boolean)
		.join("\n\n")

let pasteCounter = 0

export const createTextPaste = (text: string): ChatInputTextPaste => {
	pasteCounter += 1
	return { id: `paste-${Date.now()}-${pasteCounter}`, text }
}
